import { useCallback, useState } from 'react';

import { useVssQuery } from './useVssQuery';
import { Kitchen } from '../libs';
import { listKitchenPeopleHistogram } from '../views/KitchenFloor/utils';

export interface PeopleHistogramVariables {
  kitchen: Kitchen;
  sensorId: string;
  from: string;
  to: string;
  buckets: number;
}

/** The people histogram of one camera, fetched once per request — the room panel and alert detail each open it lazily. */
const useKitchenPeopleHistogram = () => {
  const [variables, setVariables] = useState<PeopleHistogramVariables>();
  const { data, loading, error } = useVssQuery(
    JSON.stringify(variables ?? null),
    () =>
      variables
        ? listKitchenPeopleHistogram(variables.kitchen, variables.sensorId, variables.from, variables.to, variables.buckets)
        : Promise.resolve([]),
    variables === undefined
  );

  const request = useCallback((next: PeopleHistogramVariables) => setVariables(next), []);

  return { buckets: data ?? null, loading, error, request };
};

export default useKitchenPeopleHistogram;
